<script lang="ts">
  import Icon, { type IconName } from './Icon.svelte';
  import { t } from '../i18n/index.svelte';

  let { onDismiss }: { onDismiss: () => void } = $props();

  const hints: { icon: IconName; key: string }[] = [
    { icon: 'rotate', key: 'hints.rotate' },
    { icon: 'pan', key: 'hints.pan' },
    { icon: 'expand', key: 'hints.dblTap' },
  ];
</script>

<div
  class="scrim"
  role="button"
  tabindex="-1"
  aria-label={t('common.close')}
  onclick={onDismiss}
  onkeydown={(e) => e.key === 'Escape' && onDismiss()}
></div>
<div class="card" role="dialog" aria-modal="true" aria-label={t('hints.title')}>
  <h2>{t('hints.title')}</h2>
  <ul>
    {#each hints as h (h.key)}
      <li><span class="ico"><Icon name={h.icon} size={20} /></span>{t(h.key)}</li>
    {/each}
  </ul>
  <button class="ok" onclick={onDismiss}>{t('hints.ok')}</button>
</div>

<style>
  .scrim {
    position: fixed;
    inset: 0;
    z-index: var(--z-modal);
    background: var(--color-overlay-scrim);
    border: none;
  }
  .card {
    position: fixed;
    z-index: var(--z-modal);
    left: 50%;
    top: 38%;
    transform: translate(-50%, -50%);
    width: min(320px, calc(100vw - 2 * var(--space-lg)));
    padding: var(--space-lg);
    background: var(--color-navy);
    color: #fff;
    border-radius: var(--radius-panel);
    box-shadow: var(--shadow-panel);
    text-align: center;
  }
  h2 {
    margin: 0 0 var(--space-md);
    font-size: var(--font-size-title);
  }
  ul {
    list-style: none;
    margin: 0 0 var(--space-lg);
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-sm);
    text-align: left;
  }
  li {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    font-size: var(--font-size-body);
  }
  .ico {
    flex: none;
    display: inline-flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-control);
    background: rgba(255, 255, 255, 0.12);
    color: var(--color-primary-accent);
  }
  .ok {
    min-height: var(--size-touch-min);
    width: 100%;
    border: none;
    border-radius: var(--radius-control);
    background: var(--color-primary);
    color: #fff;
    font: inherit;
    font-weight: 700;
    cursor: pointer;
  }
  .ok:hover {
    background: var(--color-primary-accent);
  }
</style>
